import { Keyword } from "../api/Items";
import { useEffect, useState } from "react";
import KeyOutlineIcon from "./icons/KeyOutlineIcon";

function KeywordBadges({ keywords }: { keywords: Keyword[] }): JSX.Element {
  const [keywordsSet, setKeywordsSet] = useState<string[]>([]);
  useEffect(() => {
    const copyKeywords: string[] = [];
    keywords.forEach((keyword) => {
      keyword.matches.include_exact.forEach((word) => {
        if (!copyKeywords.includes(word)) copyKeywords.push(word);
      });
      keyword.matches.include_fuzzy.forEach((word) => {
        if (!copyKeywords.includes(word)) copyKeywords.push(word);
      });
    });
    setKeywordsSet(copyKeywords);
  }, [keywords]);
  return (
    <>
      <span className="inline-flex items-center">
        <span className="self-start pr-4">
          <KeyOutlineIcon />
        </span>
        <div className="flex flex-wrap gap-2">
          {keywordsSet.map((keyword) => (
            <span
              className="inline-flex items-center bg-gray-100 py-1 px-3 rounded-md text-black-800 text-xs font-medium"
              key={keyword}
            >
              {keyword}
            </span>
          ))}
        </div>
      </span>
    </>
  );
}

export default KeywordBadges;
